/**
 * BuyerJourneyDefinition (AJIP-16.02.007 · WS1)
 * Version 2 enriched Buyer Journey (Founder Ruling B1).
 * Registered via RegistrationService.replace().
 */
import { STATES } from '../core/JourneyState';

const buildBuyerDefinition = ({ version = 2, nowFn = () => new Date().toISOString() } = {}) => ({
  journeyId: 'buyer',
  journeyVersion: version,
  journeyName: 'Buyer Journey',
  journeyDescription: 'Governed buyer sourcing pathway: intent → discovery → shortlist → RFQ → decision → engagement.',
  journeyType: 'buyer',
  journeyCategory: 'sourcing',
  // Founder Ruling B2 — anonymous deferred.
  journeyAudience: ['authenticated', 'authorised-buyer'],
  registrationStatus: 'registered',
  requiredFeatureFlags: ['JOURNEYS_ENABLED'],
  entryConditions: [],
  // Founder Ruling B6 — no `no-reentry-after:completed`. Buyer is re-entrant.
  eligibilityRules: ['conflicts-with:supplier'],
  permissionRequirements: [],
  initialState: STATES.NOT_STARTED,
  supportedStates: [
    STATES.NOT_STARTED, STATES.STARTED, STATES.IN_PROGRESS,
    STATES.WAITING, STATES.BLOCKED, STATES.COMPLETED,
    STATES.CANCELLED, STATES.FAILED,
  ],
  transitionConfiguration: [
    { from: STATES.STARTED, event: 'proceed', to: STATES.IN_PROGRESS },
    { from: STATES.IN_PROGRESS, event: 'wait', to: STATES.WAITING },
    { from: STATES.WAITING, event: 'resume', to: STATES.IN_PROGRESS },
    { from: STATES.IN_PROGRESS, event: 'complete', to: STATES.COMPLETED },
    { from: STATES.IN_PROGRESS, event: 'cancel', to: STATES.CANCELLED },
    { from: STATES.IN_PROGRESS, event: 'fail', to: STATES.FAILED },
    { from: STATES.WAITING, event: 'cancel', to: STATES.CANCELLED },
    { from: STATES.STARTED, event: 'cancel', to: STATES.CANCELLED },
  ],
  // Founder Ruling B5 — internal reference, provider-agnostic.
  persistencePolicyRef: 'buyer:v2:standard',
  retentionPolicyRef: 'buyer:v2:standard',
  priority: 20,
  tags: ['buyer', 'sourcing', 'ajip-16.02.007'],
  canonReference: 'AJIP-16.02.007',
  owner: 'Founder',
  createdAt: nowFn(),
  updatedAt: nowFn(),
  deprecationStatus: 'none',
  replacementJourneyId: null,
});

export { buildBuyerDefinition };
